import { allocationsAPI } from './api';

const allocationsService = {
  // Get batch suggestions for a student
  suggestBatches: (studentId, options = {}) => {
    return allocationsAPI.suggestBatches({ studentId, ...options });
  },

  // Assign student to batch
  assignStudent: (assignmentData) => {
    return allocationsAPI.assignStudent(assignmentData);
  },

  // Get available teachers for new batch
  getAvailableTeachers: (studentId, batchType) => {
    return allocationsAPI.getAvailableTeachers(studentId, batchType);
  },

  // Validate assignment
  validateAssignment: (params) => {
    return allocationsAPI.validateAssignment(params);
  },

  // Get student assignments
  getStudentAssignments: (studentId) => {
    return allocationsAPI.getStudentAssignments(studentId);
  },

  // Get batch assignments
  getBatchAssignments: (batchId) => {
    return allocationsAPI.getBatchAssignments(batchId);
  },

  // Remove assignment
  removeAssignment: (assignmentId) => {
    return allocationsAPI.removeAssignment(assignmentId);
  },

  // Update assignment status
  updateAssignmentStatus: (assignmentId, status) => {
    return allocationsAPI.updateAssignmentStatus(assignmentId, status);
  },

  // Get allocation stats
  getStats: (params) => {
    return allocationsAPI.getStats(params);
  },

  // Bulk assign
  bulkAssign: (data) => {
    return allocationsAPI.bulkAssign(data);
  },

  // Get unassigned students
  getUnassignedStudents: (params) => {
    return allocationsAPI.getUnassignedStudents(params);
  },

  // Auto assign
  autoAssign: (data) => {
    return allocationsAPI.autoAssign(data);
  }
};

export default allocationsService;
